import React from 'react';
import { Container } from '@drivekyte/web-components';
import { useMedia } from '@drivekyte/ui';
import ClaimDiscount from '@/pages/blog/components/claim-discount';
import PostItem from '@/pages/blog/components/post-item';
import { MainPageConfig, Post } from '@/pages/blog/types';
import { getStyles } from './styles';

type PostsListProps = {
  posts: Post[];
  mainPageConfig: MainPageConfig;
};

const PostsList = ({ mainPageConfig, posts }: PostsListProps) => {
  const media = useMedia();

  const styles = getStyles(
    mainPageConfig?.numberOfPostsPerRow || 3,
    media.xs,
    media.sm,
  );

  const claimDiscountTilePosition = mainPageConfig?.claimDiscountTilePosition
    ? mainPageConfig.claimDiscountTilePosition - 1
    : 5;
  const showClaimDiscountTile = mainPageConfig?.showClaimDiscountTile
    ? posts.length > claimDiscountTilePosition
    : false;

  const allPosts = posts.map((post: Post) => (
    <PostItem
      key={post.id}
      slug={post.attributes.slug}
      title={post.attributes.title}
      author={post.attributes.author.name}
      date={post.attributes.date}
      image={post.attributes.meta.shareImage || post.attributes.headlineImage}
    />
  ));

  if (showClaimDiscountTile) {
    allPosts.splice(
      claimDiscountTilePosition,
      0,
      <ClaimDiscount data={mainPageConfig.discountTile} />,
    );
  }

  return (
    <Container>
      <div style={styles.gridContainer}>{allPosts}</div>
    </Container>
  );
};

export default PostsList;
